/**
 *
 * RecordControlPanel
 *
 */

import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"
import { compose } from "redux"

import injectReducer from "utils/injectReducer"
import injectSaga from "utils/injectSaga"
import moment from "moment"
import { map, truncate } from "lodash"
import { Tooltip } from "antd"
import Loader from "components/Loader"
import reducer from "./reducer"
import saga from "./saga"
import { getFileHistoryWatcher, downloadFileWatcher } from "./actions"
import {
  makeSelectFileHistories,
  makeSelectIsLoadingFileHistories,
} from "./selectors"

import imageEmpty from "../../../images/empty-state-control-panel.svg"

import "./index.less"

/* eslint-disable react/prefer-stateless-function */
export class RecordControlPanel extends React.Component {
  componentDidMount = () => {
    this.props.getFileHistoryWatcher()
  }

  render() {
    const { fileHistories, isLoadingFileHistories } = this.props

    return (
      <div className="container-record-controlpanel">
        <p className="container-record-controlpanel__description">
          A continuación se presenta el historial de tus importaciones y
          exportaciones de documentos en el sistema.
        </p>
        {typeof isLoadingFileHistories === "undefined" ? (
          <Loader height="80vh" />
        ) : !fileHistories.length ? (
          <div className="container-record-controlpanel__empty">
            <img src={imageEmpty} />
            <p>Aún no cuentas con un historial para mostrar.</p>
          </div>
        ) : (
          <div style={{ height: "100%",...(typeof window.Intercom !== "undefined" &&
            window.self === window.top && {
            marginBottom: "80px"}) }} >
            <div className="container-record-controlpanel__header">
              <div>Documento</div>
              <div>Acción</div>
              <div>Fecha</div>
              <div>Usuario</div>
              <div>Browser/IOS</div>
              <div>IP</div>
            </div>
            {map(
              fileHistories,
              ({
                id_file_history,
                original_filename,
                action,
                user,
                user_agent,
                ip_address,
                date,
              }) => {
                return (
                  <div
                    className="container-record-controlpanel__body color-black"
                    key={`${original_filename}-${id_file_history}`}>
                    <div>
                      <span
                        onClick={() => {
                          this.props.downloadFileWatcher({
                            idFile: id_file_history,
                            nameFile: original_filename,
                          })
                        }}>
                        {original_filename.length > 24 ? (
                          <Tooltip title={original_filename}>
                            {truncate(original_filename, {
                              length: 24,
                              separator: "...",
                            })}
                          </Tooltip>
                        ) : (
                          original_filename
                        )}
                      </span>
                    </div>
                    <div>{action === 1 ? "Importación" : "Exportación"}</div>
                    <div>{moment(new Date(date)).format("DD/MM/YYYY")}</div>
                    <div>{user}</div>
                    <Tooltip title={user_agent}>
                      <div>
                        {truncate(user_agent, { length: 28, separator: "..." })}
                      </div>
                    </Tooltip>
                    <div>{ip_address}</div>
                  </div>
                )
              }
            )}
          </div>
        )}
      </div>
    )
  }
}

RecordControlPanel.propTypes = {
  // dispatch: PropTypes.func.isRequired,
}

const mapStateToProps = createStructuredSelector({
  fileHistories: makeSelectFileHistories(),
  isLoadingFileHistories: makeSelectIsLoadingFileHistories(),
})

function mapDispatchToProps(dispatch) {
  return {
    getFileHistoryWatcher: () => dispatch(getFileHistoryWatcher()),
    downloadFileWatcher: (params) => dispatch(downloadFileWatcher(params)),
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

const withReducer = injectReducer({ key: "recordControlPanel", reducer })
const withSaga = injectSaga({ key: "recordControlPanel", saga })

export default compose(withReducer, withSaga, withConnect)(RecordControlPanel)
